import { render, staticRenderFns } from "./FiltroRecursosProprios.vue?vue&type=template&id=1cc8b946"
import script from "./FiltroRecursosProprios.vue?vue&type=script&lang=js"
export * from "./FiltroRecursosProprios.vue?vue&type=script&lang=js"
import style0 from "./FiltroRecursosProprios.vue?vue&type=style&index=0&id=1cc8b946&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports